import {PublisherSimilarBookListModel} from "../models/publisher/publisher-similar-book-list.model";
import {ElasticSearchSort, ElasticSearchType, SearchFilters} from "../components/publisher/books/search-for-elastic";

export class BaseService {
    static sortManuscriptsByNewDate = (a: PublisherSimilarBookListModel, b: PublisherSimilarBookListModel) => {
        if (new Date(a.created) > new Date(b.created)) {
            return -1;
        }
        if (new Date(a.created) < new Date(b.created)) {
            return 1;
        }

        return 0;
    }

    static sortManuscriptsByMatching = (a: PublisherSimilarBookListModel, b: PublisherSimilarBookListModel) => {
        if (a.matching > b.matching) {
            return -1;
        }
        if (a.matching < b.matching) {
            return 1;
        }

        return 0;
    }

    static getFileName = (filePurpose: string, url: string) => {
        let splitPath = BaseService.getPathByFilePurpose(filePurpose);

        if (url) {
            const fileNameWithGuid = url.split(splitPath)[1].split('?')[0];
            const partsFileName = fileNameWithGuid.split('_');
            const fileNameWithoutGuid = partsFileName.filter((part, index) => index < partsFileName.length - 1).join('_');
            return fileNameWithoutGuid + '.' + partsFileName[partsFileName.length - 1].split('.')[1];
        } else {
            return null;
        }
    }

    static cutText = (string: string, length: number, delimiter?: string) => {
        delimiter = delimiter || "...";
        return string.length > length ? string.substr(0, length) + delimiter : string;
    };

    static getPathByFilePurpose = (filePurpose: string) => {
        const obj = {
            'CON': '/contents/',
            'TXT': '/text/',
            'ANL': '/analysis/',
            'IMG': '/images/'
        };

        return obj[filePurpose];
    }

    static parseOldMainCategory = (cat: string) => {
        if (cat) {
            switch (cat) {
                case 'Beletrystyka':
                    return 'mainCategory1';
                case 'Literatura faktu':
                    return 'mainCategory2';
                case 'Literatura dla dzieci (proza i poezja)':
                    return 'mainCategory3';
                case 'Poradniki':
                    return 'mainCategory4';
                case 'Literatura naukowa i popularnonaukowa':
                    return 'mainCategory5';
                case 'Poezja, dramat':
                    return 'mainCategory6';
                case 'Komiksy, powieści graficzne':
                    return 'mainCategory7';
                case 'Inne':
                    return 'mainCategory8';
            }

            return cat;
        } else {
            return '';
        }
    }

    static getMatchingValue = (matching: number = 0) => {
        if (matching <= 0.33) {
            return 33;
        }

        if (matching > 0.33 && matching <= 0.66) {
            return 66;
        }

        if (matching > 0.66) {
            return 100;
        }
    }
    static getElasticSearchRequest = (
        sortField: ElasticSearchSort,
        sortValue: 'asc'|'desc',
        searchType: ElasticSearchType,
        searchValue: string,
        filters: SearchFilters,
        page = 1,
        perPage = 4
    ) => {

        return {
            "search_params": {
                "query": searchValue,
                "page": page,
                "per_page": perPage,
                "sort_options": sortField ? {
                    "sort_by": BaseService.parseElasticSearchSortToApi(sortField),
                    "ordering": sortValue
                } : {}
            },
            "search_options": {
                "by_title": searchType === ElasticSearchType.searchTypeTitle,
                "by_author": searchType === ElasticSearchType.searchTypeAuthor,
                "by_tags": searchType === ElasticSearchType.searchTypeTag,
                "by_isbn": searchType === ElasticSearchType.searchTypeIsbn
            },
            "filter_params": {
                "categories": filters?.categories || [],
                "publishers": filters?.publishers || [],
                "languages": filters?.languages || [],
                "countries": filters?.countries || [],
                "tags": filters?.tags || [],
                "book_phases": filters?.bookPhases || []
            }
        }
    }

    static parseElasticSearchSortToApi = (sortField: ElasticSearchSort) => {
        switch (sortField) {
            case ElasticSearchSort.created:
                return 'created';
            case ElasticSearchSort.status:
                return 'status';
            case ElasticSearchSort.publishDate:
                return 'publish_date';
            case ElasticSearchSort.submittedDate:
                return 'submitted_date';
            case ElasticSearchSort.matching:
                return 'matching';
        }
    }
}
